import {Component, Input, OnInit} from '@angular/core';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';

@Component({
    selector: 'app-popup-video',
    templateUrl: './popup-video.component.html',
    styleUrls: ['./popup-video.component.scss']
})
export class PopupVideoComponent implements OnInit {

    @Input() videoPath: string;
    videoBytes = '';
    loading = true;

    constructor(private fileService: FileRestService) {
    }

    ngOnInit(): void {
        this.loadVideoFromPath(this.videoPath);
    }

    loadVideoFromPath(videoPath: string): void {
        this.fileService.getSingleResource(videoPath).subscribe(response => {
            let binary = '';
            const bytes = new Uint8Array(response);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            const base64String = btoa(binary);
            this.videoBytes = 'data:video/mp4;base64,' + base64String;
            this.loading = false;
        });
    }

}
